export const MuiAlert = (palette) => ({
  defaultProps: {
    'aria-label': 'alert',
  },
  styleOverrides: {
    root: {
      width: '100%',
      marginTop: '24px',
      padding: '12px',
      borderRadius: '10px',
    },
    colorError: {
      backgroundColor: palette.error[50],
    },
    colorSuccess: {
      backgroundColor: palette.success[100],
    },
  },
});
